<div class="attachment">
  <input #fileInput type="file" hidden multiple (change)="fileInputChange($event)" />

  <div
    class="attachment__dropdown"
    tuiDropdownAlign="right"
    [tuiDropdown]="attachmentMenuTemplate"
    [(tuiDropdownOpen)]="attachmentMenuOpened"
  >
    <button
      tuiIconButton
      class="attachment__button"
      type="button"
      appearance="icon"
      iconStart="@tui.paperclip"
      size="s"
    ></button>
  </div>

  <ng-template #attachmentMenuTemplate>
    <tui-data-list>
      <tui-opt-group class="attachment__menu">
        <button
          *ngFor="let item of attachmentMenuItems"
          tuiOption
          new
          class="attachment__menu-item attachment-menu-item"
          (click)="onClickAttachmentMenuItem(item)"
        >
          <app-icon *ngIf="item.icon" class="attachment-menu-item__icon" [src]="item.icon"></app-icon>
          <span class="attachment-menu-item__title">{{ item.title }}</span>
        </button>
      </tui-opt-group>
    </tui-data-list>
  </ng-template>

  <ng-template #confirmAttachmentDialog let-observer>
    <chat-attachment-dialog
      [messageText]="messageText"
      [observer]="observer"
      [attachmentsPreview]="currentAttachmentPreview"
      (attachmentConfirmed)="onConfirmedAttachment($event)"
    ></chat-attachment-dialog>
  </ng-template>
</div>
